export const SUB_MENU_DEFAULT_KEYS = {
  id: 'name',
  label: 'title',
  value: 'name',
}
